import { createAction, props } from '@ngrx/store'
import { ProfileItemActivitiesEntity } from './profile-item-activities.models'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'

export const loadProfileItemActivities = createAction(
  '[ProfileItemActivities Page] Load Profile Item Activities',
  (showLoader: boolean = true) => ({ showLoader }),
)

export const loadProfileItemActivitiesSuccess = createAction(
  '[ProfileItemActivities/API] Load Profile Item Activities Success',
  props<{ activities: ProfileItemActivitiesEntity[] }>(),
)

export const loadProfileItemActivitiesFailure = createAction(
  '[ProfileItemActivities/API] Load Profile Item Activities Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const syncProfileItemActivity = createAction(
  '[ProfileItemActivities/API] Sync Profile Item Activity',
  props<{ uuid: string }>(),
)

export const syncProfileItemActivityFailure = createAction(
  '[ProfileItemActivities/API] Sync Profile Item Activity Failure',
  props<{ error: HttpErrorResponse; uuid?: string }>(),
)

export const addProfileItemActivity = createAction(
  '[ProfileItemActivities/API] Add Profile Item Activity',
  props<{ activity: ProfileItemActivitiesEntity }>(),
)

export const updateProfileItemActivity = createAction(
  '[ProfileItemActivities/API] Update Profile Item Activity',
  props<{ update: Update<ProfileItemActivitiesEntity> }>(),
)

export const deleteProfileItemActivity = createAction(
  '[ProfileItemActivities/API] Delete Profile Item Activity',
  props<{ uuid: string }>(),
)

export const updateSelectedProfileItemActivityId = createAction(
  '[ProfileItemActivities Page] Update Selected Profile Item Activity ID',
  props<{ uuid: string }>(),
)

export const clearSelectedProfileItemActivityId = createAction(
  '[ProfileItemActivities Page] Clear Selected Profile Item Activity ID',
)

export const clearProfileItemActivities = createAction('[ProfileItemActivities] Clear Profile Item Activities')

export const loadProfileItemActivityVolunteer = createAction(
  '[ProfileItemActivities/API] Load Profile Item Activity Volunteer',
)

export const loadProfileItemActivityVolunteerSuccess = createAction(
  '[ProfileItemActivities/API] Load Profile Item Activity Volunteer Success',
)
